import { z } from 'zod';
import { SalesOrderDeliveryType } from '../../../constants/sales-order-delivery-type/index.js';
import { DELIVERY_TYPE_REQUIRED_MESSAGE } from '../delivery-assignee/index.js';
// sales_order.delivery_type_id: one of the seeded SalesOrderDeliveryType ids (N37).
export const deliveryTypeIdSchema = z.enum(SalesOrderDeliveryType, {
    error: (issue) => issue.input === undefined || issue.input === null
        ? DELIVERY_TYPE_REQUIRED_MESSAGE
        : 'Invalid delivery type selection.',
});
//# sourceMappingURL=delivery-type-id-schema.js.map